import { useFormat } from 'vivat';

export default {
  types: {
    // _primaryControls: {
    //   width: '3rem',
    // },
    // _secondaryControls: {
    //   width: '3rem',
    // },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    createdAt: {
      name: 'วันทำรายการ',
      width: '10rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    date: {
      name: 'วันที่ชำระ',
      width: '6rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDate(),
    },
    'account.code': {
      name: 'รหัสบัญชี',
      width: '6rem',
      class: 'text-center',
      filter: (val: any, row: any) => row.item.account.code,
    },
    // eslint-disable-next-line
    payment_account_id: {
      name: 'หมวดหมู่',
      width: '10rem',
      filter: (val: any, row: any) => row.item.account.name,
    },
    name: {
      name: 'รายการ',
      width: '1fr',
    },
    amount: {
      name: 'รายจ่าย',
      width: '6rem',
      filter: (val: string) => useFormat.number(val).currency(),
    },
    createdBy: {
      name: 'ผู้ทำรายการ',
      width: '8rem',
      // eslint-disable-next-line
      filter: (val: any) => val ? val.name : '',
    },
  },
  sortable: [
    'name',
    'payment_account_id',
  ],
};
